import type { GetUserPropertiesByLocationRepository } from './interfaces/GetUserPropertiesByLocationRepository'
import type { GetUserPropertiesByLocationPresentation } from './interfaces/GetUserPropertiesByLocationPresentation'
import type { Locale } from '../../../../types'
import UserProperties from '../../domain/UserProperties'

export default class GetUserPropertiesByLocationUseCase {
  constructor(private repository: GetUserPropertiesByLocationRepository) {}

  async execute(
    presenter: GetUserPropertiesByLocationPresentation,
    input: { locale: Locale },
  ) {
    const locationDetails = await this.repository.getUserLocation()
    const userProperties = new UserProperties(
      input.locale,
      locationDetails,
    ).build()

    presenter.displayUserLocaleProperties(userProperties)
  }
}
